export default __webpack_public_path__ + "static/media/Prophecy_Cn.6a894ebe.webp";